import { SaveIcon } from 'lucide-react';

interface FloatingSaveButtonProps {
  onClick: () => Promise<void> | void;
  isLoading?: boolean;
}

const FloatingSaveButton: React.FC<FloatingSaveButtonProps> = ({ onClick, isLoading = false }) => {
  return (
    <div className='fixed bottom-6 right-6'>
      <button
        onClick={onClick}
        disabled={isLoading}
        className={`flex items-center justify-center gap-2 p-4 pl-8 pr-8 ${
          isLoading ? 'bg-gray-500' : 'bg-green-700 hover:bg-green-800'
        } text-white rounded-full shadow-lg`}
      >
        {isLoading ? (
          <>
            <div className='h-5 w-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
            <span>Saving...</span>
          </>
        ) : (
          <>
            <SaveIcon size={20} />
            <span>Save</span>
          </>
        )}
      </button>
    </div>
  );
};

export default FloatingSaveButton;
